<template>
    <router-view :key="`view_${$route.fullPath}`"/>
</template>

<script>
export default {
    name: "blank-layout"
};
</script>